import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Impersonate from '../components';


function mapStateToProps() {
  return {};
}

function mapDispatchToProps() {
  return {};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Impersonate));



// WEBPACK FOOTER //
// ./src/routes/Impersonate/container/index.js